import {useEffect} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import NotFoundImage from '../../../../assets/image/404.png';
import DotsLoading from '../../../../components/dotsLoading';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetListContractedStore from '../../../../services/hookService/getListContractedStore/useGetListContractedStore';

const CityStoresPage = () => {
  const navigate = useNavigate();
  const backRoute = '/my-credits/startLoanCredit';

  const {state} = useLocation() as {state: {show404Toast: boolean}};
  const {stateId} = useParams();

  const {data, loaderRef, isFetchingNextPage, isLoading} =
    useGetListContractedStore(stateId as string);

  const handleNavigateToStore = (storeGuid: string) => {
    navigate(`/shop-card-detail/${storeGuid}`);
  };

  useEffect(() => {
    if (!state?.show404Toast) return;
    toast.error(
      'شما سفارشی در فروشگاه طرف قرار داد ندارید لطفا ابتدا سفارش خود را در فروشگاه های طرف قرار ثبت کنید ',
    );
  }, []);

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div className="relative flex items-center gap-2 cursor-pointer">
            <span className="font-medium">فروشگاه‌های استان</span>
          </div>
        )}
        postComponent={() => (
          <i
            onClick={() => navigate(backRoute)}
            className="icon-nameClose-remove text-[25px] text-gray-700"
          />
        )}
      />

      <div className="flex flex-col w-full h-full p-3 overflow-y-auto">
        {isLoading && (
          <div className="grid h-full place-content-center">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && data?.length === 0 && (
          <div className="flex flex-col items-center justify-center w-full h-full gap-4">
            <img src={NotFoundImage} alt="page-not-found" />
            <p className="text-gray-700 text-md font-Regular">
              هیچ فروشگاه طرف قراردادی در این استان وجود ندارد
            </p>
          </div>
        )}

        {!isLoading && data && data.length > 0 && (
          <div className="grid grid-cols-4 gap-3">
            {data.map(store => (
              <div
                key={store.guid}
                className="flex flex-col items-center justify-start gap-2 text-center"
                onClick={() => handleNavigateToStore(store.guid)}
              >
                <img
                  src={store.logo}
                  alt={store.title}
                  className="flex items-center justify-center w-12 h-12 text-sm text-white rounded-full border border-[1px] "
                />
                <span className="text-sm line-clamp-2">{store.title}</span>
              </div>
            ))}

            {/* This div acts as a sentinel for triggering infinite scroll */}
            <div ref={loaderRef} className="mt-4 text-center">
              {isFetchingNextPage ? <DotsLoading /> : null}
            </div>
          </div>
        )}
      </div>

      {/* Footer Button */}
      <div className="w-full flex gap-2 p-3 bg-white shadow-[0_-1px_6px_0_rgba(0,0,0,0.1)]">
        <button
          type="button"
          onClick={() => navigate(backRoute)}
          className="w-full h-12 text-white rounded-lg bg-farm-shop-500 disabled:bg-gray-300 disabled:text-gray-700"
        >
          متوجه شدم
        </button>
      </div>
    </div>
  );
};
export default CityStoresPage;
